import { Link } from 'react-router-dom';
import { FiShoppingCart, FiStar } from 'react-icons/fi';
import { useCart } from '../../context/CartContext';
import toast from 'react-hot-toast';

export default function ProductCard({ product }) {
  const { addToCart } = useCart();

  const handleQuickAdd = (e) => {
    e.preventDefault();
    const defaultSize = product.sizes?.[0]?.size || 'M';
    addToCart(product, defaultSize, 1);
    toast.success(`${product.name} added to cart!`);
  };

  const displayPrice = product.salePrice || product.price;
  const hasDiscount  = product.salePrice && product.salePrice < product.price;

  return (
    <Link to={`/product/${product._id}`} className="group block">
      <div className="relative overflow-hidden rounded-xl bg-yamass-cream aspect-[3/4]">
        {product.images?.[0] ? (
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gray-100 text-gray-400 text-sm">
            No Image
          </div>
        )}

        {hasDiscount && (
          <span className="absolute top-3 left-3 bg-yamass-red text-white text-xs px-2 py-1 rounded-full font-medium">
            Sale
          </span>
        )}

        {product.isFeatured && (
          <span className="absolute top-3 right-3 bg-yamass-accent text-white text-xs px-2 py-1 rounded-full font-medium">
            Featured
          </span>
        )}

        <button
          onClick={handleQuickAdd}
          className="absolute bottom-3 left-1/2 -translate-x-1/2 bg-yamass-black text-white text-xs px-4 py-2 rounded-full flex items-center gap-2 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 whitespace-nowrap"
        >
          <FiShoppingCart size={13} />
          Quick Add
        </button>
      </div>

      <div className="mt-3 px-1">
        <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">{product.category}</p>
        <h3 className="text-sm font-medium text-yamass-black line-clamp-2">{product.name}</h3>

        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-yamass-black">৳{displayPrice.toLocaleString()}</span>
            {hasDiscount && (
              <span className="text-xs text-gray-400 line-through">৳{product.price.toLocaleString()}</span>
            )}
          </div>
          {product.ratings?.average > 0 && (
            <div className="flex items-center gap-1 text-xs text-gray-400">
              <FiStar size={11} className="text-yamass-accent fill-yamass-accent" />
              {product.ratings.average.toFixed(1)}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
